/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETEXPERIENCEBYID= createAsyncThunk(
  "getExperienceById/getExperienceById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getExperienceByIdSlice = createSlice({
  name: "getExperienceByIdSlice",
  initialState: {
    getExperienceById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetExperienceById: (state) => {
        state.getExperienceById.loading = false
        state.getExperienceById.error = false
        state.getExperienceById.data = []
        state.getExperienceById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEXPERIENCEBYID.fulfilled, (state, action) => {
      state.getExperienceById = {
        ...state.getExperienceById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEXPERIENCEBYID.pending, (state, action) => {
      state.getExperienceById = {
        ...state.getExperienceById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEXPERIENCEBYID.rejected, (state, action) => {
      state.getExperienceById = {
        ...state.getExperienceById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getExperienceByIdAction = {
    GETEXPERIENCEBYID,
};

export { getExperienceByIdAction };
export default getExperienceByIdSlice.reducer;
export const {setInitialStateOfgetExperienceById} = getExperienceByIdSlice.actions